<script lang="ts">
	import { Txt } from '../../../../../components/Txt';

	interface Props {
		dataCy: string;
		shortDescription: string | null | undefined;
	}

	let { dataCy, shortDescription }: Props = $props();
</script>

{#if shortDescription}
	<Txt data-cy={`${dataCy}-description`} variant="body1" class="mb-2 text-gray-700">
		{shortDescription}
	</Txt>
{/if}
